import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import styled, { css } from 'styled-components';
import { getBackgroundColor, getBorderColor, getTextColor, themeGet } from '@magalu/stereo-ui-styles';
import { typography } from 'styled-system';
import { Search } from '@magalu/stereo-ui-icons';
import Flex from '../../../atoms/Flex';
export const SearchIcon = styled(Search)`
  fill: ${themeGet('palette.primary.base')};
  ${({
  desktopMode
}) => desktopMode ? css`
          width: 22px;
          height: 22px;
          min-width: unset;
        ` : css`
          width: 30px;
        `}
`;
export const ContainerInput = styled(Flex)`
  align-items: center;
  width: 100%;
  border: 0;
  padding: ${themeGet('space.1')}px ${themeGet('space.2')}px;

  svg {
    cursor: pointer;
    min-width: 18px;
  }
  ${({
  desktopMode
}) => !desktopMode && css`
      background-color: ${props => getBackgroundColor('white')(props)};
      border-radius: ${themeGet('radii.default')};
    `}
  ${({
  inputChange
}) => inputChange && css`
      ${({
  desktopMode
}) => desktopMode ? css`
              border-bottom: 1px solid ${getBorderColor('whisper')};
            ` : css`
              box-shadow: ${themeGet('boxShadows.4')};
              z-index: ${themeGet('zIndices.3')};
              border-radius: unset;
            `};
    `}
  form {
    width: 100%;
    ${({
  desktopMode
}) => !desktopMode && css`
        padding-left: ${themeGet('space.1')}px;
      `};
  }
`;
export const Input = styled.input.attrs(props => Object.assign({
  fontSize: 1
}, props))`
  color: ${_ref => {
  let {
    isChanging,
    desktopMode
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["isChanging", "desktopMode"]);

  return getTextColor(isChanging && !desktopMode ? 'primary' : 'light')(props);
}};
  caret-color: ${getTextColor('light')};
  width: 100%;
  border: 0px;
  -webkit-appearance: textfield;

  ::placeholder {
    color: ${getTextColor('light')};
  }

  ::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
  ${typography}
`;